import { Button } from '@vfz/ui';
import styled from 'styled-components';

export const EscapeLink = styled(Button)`
  text-decoration: underline;
  font-weight: 600;
`;
